import script from "./cotizacionNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./cotizacionNew.vue?vue&type=script&setup=true&lang=ts"

import "./cotizacionNew.vue?vue&type=style&index=0&id=30e12730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e12730"]])

export default __exports__